import React from 'react';

import styles from './Notification.module.css';

const notificationTypes = {
    "default": { color: "bg-primary", icon: null },
    "success": { color: "bg-success", icon: "fa-check-circle" },
    "warning": { color: "bg-warning", icon: "fa-exclamation-triangle" },
    "info": { color: "bg-info", icon: "fa-info-circle" },
    "danger": { color: "bg-danger", icon: "fa-times-circle" }
}

const Notification = (props) => {
    const type = notificationTypes[props.type || "default"];

    return (
        <div className={["text-white", type.color, styles.notification].join(" ")}
            onMouseEnter={props.onPauseTimer}
            onMouseLeave={props.onResumeTimer}
            onClick={e => props.click(e)}
        >
            {type.icon ? <i className={["fa", type.icon, styles.icon].join(" ")} /> : null}
            {props.message}
        </div>
    );
}

export default Notification;